module.exports = __webpack_public_path__ + "img/building-06.b6f04ea6.svg";